(function () {
  var DEFAULT_WORKER_URL = 'https://cakemiami-product-reviews.pavlovacake305.workers.dev';
  var DEFAULT_GBP_WORKER_URL = 'https://cakemiami-gbp-reviews.pavlovacake305.workers.dev';
  var SELECTOR = '[data-caketrack-review-summary]';
  var GBP_COUNT_SELECTOR = '[data-caketrack-gbp-review-count]';
  var GBP_FACES_SELECTOR = '[data-caketrack-gbp-review-faces]';
  var statsCache = new Map();
  var gbpStatsPromise = null;
  var gbpReviewsPromise = null;

  function statsUrl(base, handle) {
    var url = new URL('/api/reviews/stats', base || DEFAULT_WORKER_URL);
    url.searchParams.set('product', handle);
    url.searchParams.set('noCache', '1');
    return url.toString();
  }

  function getStats(base, handle) {
    var productHandle = String(handle || '').trim();
    if (!productHandle) return Promise.reject(new Error('Missing product handle'));

    var workerUrl = base || DEFAULT_WORKER_URL;
    var cacheKey = workerUrl + '|' + productHandle;
    if (!statsCache.has(cacheKey)) {
      statsCache.set(cacheKey, fetch(statsUrl(workerUrl, productHandle), { cache: 'no-store' })
        .then(function (response) {
          if (!response.ok) throw new Error('Review stats failed');
          return response.json();
        })
        .catch(function (error) {
          statsCache.delete(cacheKey);
          throw error;
        }));
    }
    return statsCache.get(cacheKey);
  }

  function gbpStatsUrl(base) {
    var url = new URL('/api/reviews/stats', base || DEFAULT_GBP_WORKER_URL);
    url.searchParams.set('location', 'all');
    url.searchParams.set('noCache', '1');
    return url.toString();
  }

  function getGbpStats(base) {
    var workerUrl = base || DEFAULT_GBP_WORKER_URL;
    if (!gbpStatsPromise) {
      gbpStatsPromise = fetch(gbpStatsUrl(workerUrl), { cache: 'no-store' })
        .then(function (response) {
          if (!response.ok) throw new Error('GBP review stats failed');
          return response.json();
        })
        .catch(function (error) {
          gbpStatsPromise = null;
          throw error;
        });
    }
    return gbpStatsPromise;
  }

  function gbpReviewsUrl(base, limit) {
    var url = new URL('/api/reviews/list', base || DEFAULT_GBP_WORKER_URL);
    url.searchParams.set('location', 'all');
    url.searchParams.set('minRating', '5');
    url.searchParams.set('limit', String(limit || 80));
    return url.toString();
  }

  function getGbpReviews(base) {
    var workerUrl = base || DEFAULT_GBP_WORKER_URL;
    if (!gbpReviewsPromise) {
      gbpReviewsPromise = fetch(gbpReviewsUrl(workerUrl, 80), { cache: 'no-store' })
        .then(function (response) {
          if (!response.ok) throw new Error('GBP reviews failed');
          return response.json();
        })
        .catch(function (error) {
          gbpReviewsPromise = null;
          throw error;
        });
    }
    return gbpReviewsPromise;
  }

  function readStats(stats) {
    return {
      total: Math.max(0, Math.round(Number(stats.totalReviews || stats.total_reviews || stats.total || 0))),
      average: Math.max(0, Number(stats.averageRating || stats.average_rating || 0)),
    };
  }

  function reviewWord(total) {
    return total === 1 ? 'review' : 'reviews';
  }

  function maxLabel(max) {
    return Math.round(max) === max ? String(max) : max.toFixed(1);
  }

  function starText(rating) {
    var count = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    return '★★★★★'.slice(0, count) + '☆☆☆☆☆'.slice(0, 5 - count);
  }

  function ratingDecimal(rating) {
    var decimal = rating % 1;
    if (decimal >= 0.3 && decimal <= 0.7) return 0.5;
    if (decimal > 0.7) return 1;
    return 0;
  }

  function updateSummary(root, stats) {
    var summary = readStats(stats);
    var total = summary.total;
    var average = summary.average;
    var max = Number(root.dataset.ratingMax || 5) || 5;
    var word = reviewWord(total);
    var a11yTotalReviews = root.dataset.a11yTotalReviews || ('total ' + word);
    var ariaLabel = 'Rated ' + average.toFixed(1) + ' out of ' + maxLabel(max) + ' stars from ' + total + ' ' + word;
    var ratingEl = root.querySelector('[data-review-rating]');
    var starStyleEl = root.querySelector('[data-review-star-style]');
    var starTextEl = root.querySelector('[data-review-stars]');
    var ratingTextEl = root.querySelector('[data-review-rating-text]');
    var countTextEl = root.querySelector('[data-review-count-text]');
    var countA11yEl = root.querySelector('[data-review-count-a11y]');

    root.hidden = total <= 0;
    if (total <= 0) return;

    if (root.hasAttribute('aria-label')) {
      root.setAttribute('aria-label', ariaLabel);
    }

    if (ratingEl) {
      ratingEl.setAttribute('aria-label', ariaLabel);
    }

    if (starStyleEl) {
      starStyleEl.style.setProperty('--rating', Math.floor(average));
      starStyleEl.style.setProperty('--rating-max', max);
      starStyleEl.style.setProperty('--rating-decimal', ratingDecimal(average));
    }

    if (starTextEl) {
      starTextEl.textContent = starText(average);
    }

    if (ratingTextEl) {
      ratingTextEl.textContent = average.toFixed(1) + ' / ' + maxLabel(max);
    }

    if (countTextEl) {
      countTextEl.textContent = root.dataset.countFormat === 'parentheses'
        ? '(' + total + ')'
        : total + ' ' + word;
    }

    if (countA11yEl) {
      countA11yEl.textContent = total + ' ' + a11yTotalReviews;
    }
  }

  function readGbpReviewCount(stats) {
    return Math.max(0, Math.round(Number(stats.totalReviews || stats.total_reviews || stats.total || 0)));
  }

  function updateGbpReviewCount(el, total) {
    var format = el.dataset.gbpReviewCountFormat || 'short';
    var word = total === 1 ? 'Review' : 'Reviews';
    if (format === 'full') {
      el.textContent = 'Based on ' + total + ' Google ' + word;
    } else if (format === 'reviews_only') {
      el.textContent = total + ' ' + word;
    } else {
      el.textContent = total + ' Google ' + word;
    }
  }

  function isPublicGbpProfilePhoto(url) {
    if (!url) return false;
    try {
      var parsed = new URL(url);
      return parsed.protocol === 'https:' &&
        parsed.hostname === 'lh3.googleusercontent.com' &&
        parsed.pathname.indexOf('/a-/') !== -1;
    } catch (error) {
      return false;
    }
  }

  function sizedGoogleAvatar(url) {
    return String(url || '').replace(/=s\d+.*$/, '') + '=s64-c';
  }

  function escAttr(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function updateGbpReviewFaces(el, data) {
    var limit = Math.max(1, Math.min(6, Number(el.dataset.gbpReviewFaceLimit || 5) || 5));
    var reviews = Array.isArray(data.reviews) ? data.reviews : [];
    var seen = {};
    var photos = [];

    reviews.forEach(function (review) {
      if (photos.length >= limit) return;
      if (!review || review.reviewer_is_anonymous) return;
      var photoUrl = review.reviewer_profile_photo_url;
      if (!isPublicGbpProfilePhoto(photoUrl) || seen[photoUrl]) return;
      seen[photoUrl] = true;
      photos.push({
        url: sizedGoogleAvatar(photoUrl),
        name: review.reviewer_display_name || 'Google reviewer',
      });
    });

    if (!photos.length) return;

    el.innerHTML = photos.map(function (photo, index) {
      var priority = index < 3 ? ' fetchpriority="high"' : '';
      return '<img class="announcement-bar__face" src="' + escAttr(photo.url) + '" alt="" loading="eager" decoding="async" referrerpolicy="no-referrer"' + priority + '>';
    }).join('');
    el.hidden = false;
  }

  function findSummaries(scope) {
    var roots = [];
    var searchRoot = scope || document;
    if (searchRoot.matches && searchRoot.matches(SELECTOR)) roots.push(searchRoot);
    searchRoot.querySelectorAll(SELECTOR).forEach(function (root) {
      roots.push(root);
    });
    return roots;
  }

  function refresh(scope) {
    findSummaries(scope).forEach(function (root) {
      getStats(root.dataset.workerUrl, root.dataset.productHandle)
        .then(function (stats) {
          updateSummary(root, stats);
        })
        .catch(function () {
          // Keep the server-rendered Shopify metafield value if CakeTrack stats are unavailable.
        });
    });

    (scope || document).querySelectorAll(GBP_COUNT_SELECTOR).forEach(function (el) {
      getGbpStats()
        .then(function (stats) {
          updateGbpReviewCount(el, readGbpReviewCount(stats));
        })
        .catch(function () {
          // Keep the server-rendered Shopify metaobject value if GBP stats are unavailable.
        });
    });

    (scope || document).querySelectorAll(GBP_FACES_SELECTOR).forEach(function (el) {
      getGbpReviews()
        .then(function (data) {
          updateGbpReviewFaces(el, data || {});
        })
        .catch(function () {
          // The face stack is additive; keep the text-only bar if profile photos fail.
        });
    });
  }

  window.CakeTrackReviewStats = {
    getGbpStats: getGbpStats,
    getGbpReviews: getGbpReviews,
    getStats: getStats,
    refresh: refresh,
    updateGbpReviewFaces: updateGbpReviewFaces,
    updateGbpReviewCount: updateGbpReviewCount,
    updateSummary: updateSummary,
  };

  document.addEventListener('DOMContentLoaded', function () {
    refresh(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    refresh(event.target);
  });
})();
